import ResponsiveLogo from '@assets/images/ResponsiveLogo.png';
import Logo from '@assets/images/white-logo.png';
import { Layout, Menu, type MenuProps } from '@components';
import cs from 'classnames';
import { useEffect, useState } from 'react';
import { AiOutlineCaretLeft, AiOutlineCaretRight } from 'react-icons/ai';
import { PiBooks, PiUserBold } from 'react-icons/pi';
import { RiAppsLine, RiHome5Line, RiLogoutCircleLine } from 'react-icons/ri';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { BiWorld } from 'react-icons/bi';
import { MdChildCare } from 'react-icons/md';

const { Sider } = Layout;

const DashboardSider = () => {
  const [collapsed, setCollapsed] = useState(false);
  type MenuItem = Required<MenuProps>['items'][number];
  const { pathname, hash } = useLocation();
  const navigate = useNavigate();
  const width = window.innerWidth;
  useEffect(() => {
    if (width < 1000) {
      setCollapsed(true);
    }
  }, [width]);
  const handleSelectKey = (item: string) => {
    if (item === 'logout') {
      localStorage.clear();
      // Dispatch custom event to notify store
      window.dispatchEvent(new Event('authStateCleared'));
      navigate('/');
    } else {
      navigate(item);
    }
  };

  const items: MenuItem[] = [
    {
      key: '/',
      icon: <RiHome5Line size={18} />,
      label: 'Home',
    },
    {
      key: '/dashboard',
      icon: <RiAppsLine size={18} />,
      label: 'Dashboard',
      className:
        `${pathname}${hash}` === '/dashboard' ? 'ant-menu-item-selected' : '',
    },
    {
      key: '/dashboard/library',
      icon: <PiBooks size={18} />,
      label: 'My library',
      className:
        `${pathname}${hash}` === '/dashboard/library'
          ? 'ant-menu-item-selected'
          : '',
    },
    {
      key: '/dashboard/tadatoonLibrary',
      icon: <BiWorld size={18} />,
      label: 'Tadatoon Library',
      className:
        `${pathname}${hash}` === '/dashboard/tadatoonLibrary'
          ? 'ant-menu-item-selected'
          : '',
    },

    {
      key: '/dashboard/profile',
      icon: <PiUserBold size={18} />,
      label: 'Profile',
      className:
        `${pathname}${hash}` === '/dashboard/profile'
          ? 'ant-menu-item-selected'
          : '',
    },
    {
      key: '/dashboard/my-child',
      icon: <MdChildCare size={18} />,
      label: 'My Children',
      className:
        `${pathname}${hash}` === '/dashboard/my-child'
          ? 'ant-menu-item-selected'
          : '',
    },
    {
      key: 'logout',
      icon: <RiLogoutCircleLine size={18} />,
      label: 'Logout',
    },
  ];
  return (
    <Sider
      collapsible={width > 1000}
      collapsed={collapsed}
      // width={230}
      trigger={
        collapsed ? (
          <AiOutlineCaretRight size={20} />
        ) : (
          <AiOutlineCaretLeft size={20} />
        )
      }
      onCollapse={(value) => setCollapsed(value)}
      className={styles['sider']}>
      <div className={styles['menu']}>
        <div
          className={cs([
            styles['logo'],
            collapsed ? styles['collapsed'] : '',
          ])}>
          {collapsed ? (
            <img src={ResponsiveLogo} alt="Tadatoon Logo" />
          ) : (
            <img src={Logo} alt="Tadatoon Logo" />
          )}
        </div>
        <Menu
          theme="dark"
          defaultSelectedKeys={['1']}
          onSelect={(event) => handleSelectKey(event.key)}
          mode="inline"
          items={items}
          selectedKeys={[pathname]}
        />
      </div>
    </Sider>
  );
};

export default DashboardSider;
